import {fetchModel, postModel} from 'shared/store';
import {endpoints, types} from 'main/tools';
import CheckIn from 'main/stores/performance/CheckIn';
import { makeAutoObservable } from 'mobx';
import {setupAutosaveDraft} from 'main/tools';
import _ from 'lodash';

class MyCheckInResponseContainerState {
  history;
  match;

  checkin;

  constructor() {
    makeAutoObservable(this, {
      history: false
    });
  }

  receiveProps({history, match}) {
    this.history = history;
    this.match = match;
  }

  async load() {
    this.checkin = new CheckIn(await fetchModel(
      endpoints.PERFORMANCE.CYCLE_CHECKIN.with(this.match.params.cycleId),
      types.PERFORMANCE.CHECKIN
    ));


    const questions = _.map(this.checkin.answers, 'question');
    if (!this.checkin.completed) {
      await setupAutosaveDraft(
        this.checkin,
        {id: this.match.params.cycleId, type: types.PERFORMANCE.CHECKIN}
      );
    }
    this.checkin.regenerateAnswersForQuestions(questions);
  }

  updateAnswerContent(e, answer) {
    answer.content = e.target.value;

    this.checkin.autosaver.autosave();
  }

  async postCheckIn(checkin, cycleId) {
    await postModel(
      endpoints.PERFORMANCE.CYCLE_CHECKIN.with(cycleId),
      types.PERFORMANCE.CHECKIN,
      checkin.toJS()
    );
  }

  onSubmit = async () => {
    this.checkin.merge({reviewerEmployeeId: this.match.params.reviewerId});

    await this.postCheckIn(this.checkin, this.match.params.cycleId);
    this.history.push('/checkins');
  };
}

export default MyCheckInResponseContainerState;
